export default "__VITE_ASSET__0029b4d6__"